<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 8px;">推送时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <input-search placeholder="接收人/住户名称/房间号" @search="searchKey" />
    </div>
    <div class="search-line">
      <div class="btn-box">
        <input-select :selectTitle="'消息类型'" style="margin-right: 10px;" selectWidth="200px" :selectData="typeList" @search="search" :selectKey="'type'" />
      </div>
      <div class="btn-box">
        <input-select :selectTitle="'推送状态'" style="margin-right: 10px;" selectWidth="140px" :selectData="statusList" @search="search" :selectKey="'status'" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :hasOperation="false" @changePagination="changePagination" :row-click="showMessageDetail" />

    <el-dialog title="消息通知" :visible.sync="messageDialog" width="600px" style="text-align: left">
      <div class="message-dialog-box">
        <h3 >{{messageData.typeText}}</h3>
        <div class="messageDataFirst">{{messageData.first}}</div>
        <div class="messageMain">
          <div class="messageMainLine">
            <div class="message_title">{{messageData.meaningArr[0]}}:</div>
            <div class="message_info">{{messageData.keyword1}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.meaningArr.length > 1">
            <div class="message_title">{{messageData.meaningArr[1]}}:</div>
            <div class="message_info">{{messageData.keyword2}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.meaningArr.length > 2">
            <div class="message_title">{{messageData.meaningArr[2]}}:</div>
            <div class="message_info">{{messageData.keyword3}}</div>
          </div>
          <div class="messageMainLine" v-if="messageData.meaningArr.length > 3">
            <div class="message_title">{{messageData.meaningArr[3]}}:</div>
            <div class="message_info">{{messageData.keyword4}}</div>
          </div>
          <div class="messageMainLine" >
            <div class="message_title">备注:</div>
            <div class="message_info">{{messageData.remark}}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Message";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb,
  },
  name: "message-sed-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧消息",
          name: "message-template-manage",
        },
        {
          value: "消息推送记录",
        },
      ],
      addRouterName: "yq-zx-add",
      operationArr: ["modify", "delete"],
      timevalue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      typeList: [],
      statusList: [
        {
          key: "",
          label: "全部",
        },
        {
          key: "SUCCESS",
          label: "成功",
        },
        {
          key: "FAIL",
          label: "失败",
        },
      ],
      tableHead: [
        {
          prop: "typeText",
          label: "消息类型",
        },
        {
          prop: "remark",
          label: "提示内容",
        },
        {
          prop: "toUserName",
          label: "接收人",
          width: "90",
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
        },
        {
          prop: "roomInfoName",
          label: "房间号",
        },
        {
          prop: "statusText",
          label: "推送状态",
          width: "90",
          showColor: true,
        },
        {
          prop: "failReason",
          label: "失败原因",
        },
        {
          prop: "createTime",
          label: "推送时间",
        },
      ],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        status: "",
        type: "",
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        startTime: "",
        endTime: "",
      },

      messageDialog: false,
      messageData: {
        meaningArr: [],
      },
    };
  },
  created() {
    this.getWxEventConfigList();
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreatTime();
  },
  activated() {
    this.getWxEventConfigList()
    this.getPage()
  },
  methods: {
    // 查询类型
    getWxEventConfigList() {
      this.$axios
        .post(api.getWxEventConfigList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map((v) => {
              v.key = v.code;
              v.label = v.name;
            });
            this.typeList = data;
            this.typeList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取类型失败"));
    },
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = `${year}-${month}-${date} 23:59:59`
      this.getPage();
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getMessageRecordPage, this.requestData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              v.createTime = v.createTime.slice(0, 19);
              this.typeList.map((type) => {
                if (type.key === v.type) {
                  v.typeText = type.label;
                }
              });
              this.statusList.map((status) => {
                if (status.key === v.status) {
                  v.statusText = status.label;
                }
              });
              if (v.status === "FAIL") {
                v.fontColorToPeople = "#B22222";
              } else {
                v.fontColorToPeople = "#67C23A";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取推送记录失败"));
    },
    search(v) {
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    showMessageDetail(data) {
      data.meaningArr = data.meaning.split(",");
      this.messageData = data;
      this.messageDialog = true;
    },
  },
  watch: {
    timevalue(val) {
      this.getPage();
    },
  },
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.message-dialog-box {
  width: 500px;
  margin: 0 auto 30px;
  text-align: left;
  .messageDataFirst {
    color: #999999;
    margin-bottom: 30px;
  }
  .messageMainLine {
    display: flex;
    justify-content: flex-start;
    align-items: start;
    font-size: 16px;
    line-height: 30px;
    margin: 10px 0;
    .message_title {
      width: 100px;
      color: #999999;
    }
    .message_info {
      width: 400px;
      color: #173177;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/MessageSedManagement/MessageSedManage.vue